<template>
  <v-container fluid class="px-5">
    <v-row v-if="!isLoadingContent">
      <v-col cols="12" class="pb-0">
        <v-btn text @click="$router.push({ name: 'access-permission' })" >
          <v-icon small color="red" >mdi-arrow-left</v-icon>
          <label class="mx-2 px-2 text--disabled" style="letter-spacing: 0.6px;">Voltar</label>
        </v-btn>
      </v-col>

      <v-col cols="12" class="pb-0 mb-0">
        <v-subheader style="background-color: var(--v-subHeaderBackground-base);">Configurações de Notificações
          <v-speed-dial right fixed class="pt-16 pr-2">
            <template v-slot:activator>
              <v-btn class="buttonColor mb-5"
                     dark fab
                     @click="onClickAdd(itemParams, indexesHistory, token)">
                <v-icon class="mdi-36px">mdi-plus</v-icon>
              </v-btn>
            </template>
          </v-speed-dial>
        </v-subheader>
      </v-col>

      <v-col class="pt-0 mt-0" cols="12">
       <v-row class="">
         <v-col cols="12" class="pt-0">
           <v-data-table class="file-explorer-desktop px-4"
                         :headers="headers"
                         :items="notificationConfigs"
                         item-key="id" hide-default-footer disable-pagination>
             <template v-slot:no-data>
               Não existem configurações cadastradas.
             </template>

             <template v-slot:item.insertable="{ item }">
               <v-icon small v-if="item.insertable" color="green">
                 mdi-checkbox-marked-circle
               </v-icon>
               <v-icon small v-else color="red">
                 mdi-close-circle
               </v-icon>
             </template>

             <template v-slot:item.updatable="{ item }">
               <v-icon small v-if="item.updatable" color="green">
                 mdi-checkbox-marked-circle
               </v-icon>
               <v-icon small v-else color="red">
                 mdi-close-circle
               </v-icon>
             </template>

             <template v-slot:item.deletable="{ item }">
               <v-icon small v-if="item.deletable" color="green">
                 mdi-checkbox-marked-circle
               </v-icon>
               <v-icon small v-else color="red">
                 mdi-close-circle
               </v-icon>
             </template>

             <template class="pl-2" v-slot:item.actions="{ item }">
               <v-btn icon @click="onClickEdit(item, itemParams, indexesHistory, token)">
                 <v-icon color="muted-accent">mdi-pencil</v-icon>
               </v-btn>
               <v-btn icon @click="deleteNotificationConfig(item.id)">
                 <v-icon color="muted-accent">mdi-delete-forever</v-icon>
               </v-btn>
             </template>

             <template class="pl-2"  v-if="notificationConfigs && notificationConfigs.length > 0" slot="body.append">
               <tr class="muted--text controlscroll">
                 <td :colspan="headers.length"></td>
               </tr>
             </template>
           </v-data-table>
         </v-col>
       </v-row>
      </v-col>
    </v-row>

    <v-row v-if="!isLoadingContent">
      <v-col cols="12">
        <flash-message></flash-message>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-overlay :value="isLoadingContent" :opacity="0">
          <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        </v-overlay>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { deleteNotificationConfig, findAllNotificationConfigs } from '@/common/driveserver';


export default {
  name: 'ShowNotification',
  data: () => ({
    headers: [
      {
        text: 'ID',
        value: 'id',
        name: 'id',
        width: '5%',
        sortable: false,
      },
      {
        text: 'Path',
        value: 'pathFileDir',
        name: 'pathFileDir',
        width: '25%',
        sortable: false,
      },
      {
        text: 'Título',
        value: 'title',
        name: 'title',
        width: '25%',
        sortable: false,
      },
      {
        text: 'Notificar ao Inserir',
        value: 'insertable',
        sortable: false,
      },
      {
        text: 'Notificar ao Alterar',
        value: 'updatable',
        sortable: false,
      },
      {
        text: 'Notificar ao Deletar',
        value: 'deletable',
        sortable: false,
      },
      {
        text: '',
        value: 'actions',
        sortable: false,
        align: 'right',
      },
    ],
    indexesHistory: [],
    isLoadingContent: false,
    itemParams: null,
    notificationConfigs: [],
    token: null,
  }),
  methods: {
    onClickAdd(itemParams, indexesHistory, token) {
      this.$router.push({
        name: 'configure-notification',
        params: { id: 0, item: itemParams, indexesHistoryProps: indexesHistory },
        query: { token },
      });
    },
    onClickEdit(item, itemParams, indexesHistory, token) {
      this.$router.push({
        name: 'configure-notification',
        params: { id: item.id, item: itemParams, indexesHistoryProps: indexesHistory },
        query: { token },
      });
    },
    async deleteNotificationConfig(id) {
      this.isLoadingContent = true;
      await deleteNotificationConfig(id)
        .then(() => {
          this.flash('Configuração excluída com sucesso.', 'success', { timeout: 5000 });
        })
        .catch(() => {
          this.flash('Não foi possível excluir a configuração de notificação.', 'error', { timeout: 5000 });
        })
        .finally(() => {
          this.isLoadingContent = false;
        });
      await this.loadAllNotificationConfigs();
    },
    loadRouteParams() {
      this.token = this.$route.query.token;
      if (this.$route.params && this.$route.params.indexesHistoryProps) {
        this.indexesHistory = this.$route.params.indexesHistoryProps;
      }

      if (this.$route.params && this.$route.params.item) {
        this.itemParams = this.$route.params.item;
      }
    },
    async loadAllNotificationConfigs() {
      this.isLoadingContent = true;
      await findAllNotificationConfigs(this.itemParams.path)
        .then((response) => {
          if (response.data) {
            this.notificationConfigs = response.data;
          }
        })
        .catch(() => {
          this.flash('Não foi possível carregar as configurações de notificação.', 'error', { timeout: 5000 });
        })
        .finally(() => {
          this.isLoadingContent = false;
        });
    },
  },
  async created() {
    this.loadRouteParams();
    await this.loadAllNotificationConfigs();
  },
};
</script>

<style scoped>

.controlscroll:hover {
  color: var(--v-brightGray-base) !important;
}

</style>
